import React from "react";
import Hero from "@/components/Hero";
import FeaturedWork from "@/components/FeaturedWork";
import PortfolioGrid from "@/components/PortfolioGrid";
import Services from "@/components/Services";
import Process from "@/components/Process";
import About from "@/components/About";
import Collective from "@/components/Collective";
import Contact from "@/components/Contact";

export default function LandingPage({ onOpenAuth }) {
  return (
    <main>
      <Hero onOpenAuth={onOpenAuth} />
      <FeaturedWork />
      <PortfolioGrid />
      <Services />
      <Process />
      <About />
      <Collective />
      <Contact />
    </main>
  );
}
